module.exports = __webpack_public_path__ + "img/water_level_low.b8b5f48c.svg";